import React from 'react';
import { PickingBatchListDetailTemplate } from 'themes/modules/picking-batch/pages';
import { PickingBatchListDetailViewStore } from 'modules/picking-batch/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, props) => new PickingBatchListDetailViewStore(rootStore, props),
	'pickingBatchListDetailViewStore'
)
class PickingBatchListDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <PickingBatchListDetailTemplate store={this.props.pickingBatchListDetailViewStore} />;
	}
}

export default PickingBatchListDetail;



// WEBPACK FOOTER //
// ./src/modules/picking-batch/pages/PickingBatchListDetail.jsx